import { lazy, Suspense } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import * as WJCore from '@grapecity/wijmo';
import 'react-toastify/dist/ReactToastify.css';
import { useStore } from '../stores/store';
import { PageTransition } from '../components/page-transition';
import { Public_Routes } from '../../constants/Routes';
import './App.css';
import { NotFoundRoutes } from '../../security';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Aca colocamos la configuración de la licencia o se la quemamos
WJCore.setLicenseKey(process.env.REACT_APP_WJ_TK ?? '');
const LoginPage = lazy(() => import('../../pages/public/login/LoginPage'));
const AuthRouter = lazy(() => import('../../security/routers/AuthRouter'));

/**
 * Componente principal ya que indicamos que rutas y paginas vamos a renderizar en el navegador
 * @returns Componente que contiene la logica para definir que rutas son publicas y privadas
 */
function App() {
    const { commonStore } = useStore();
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <Suspense fallback={<PageTransition />}>
                <BrowserRouter>
                    <>
                        {commonStore.token ? (
                            <>
                                <AuthRouter />
                                <ToastContainer />
                            </>
                        ) : (
                            <NotFoundRoutes redirect={Public_Routes.LOGIN}>
                                <Route
                                    path={Public_Routes.LOGIN}
                                    element={<LoginPage />}
                                />
                            </NotFoundRoutes>
                        )}
                    </>
                </BrowserRouter>
            </Suspense>
        </QueryClientProvider>
    );
}

export default App;
